import { AssistantNoteApi } from '../Services/AssistantNoteApiProviderTypes';
import { formatDateTimeLocal } from '../utils/formatDate';
import Button from './Buttons';

export const getNoteSourceLabel = (source: string): string =>
  source === 'OPERATOR' ? 'Operator' : 'Agent';

interface AgentNoteDetailProps {
  note: AssistantNoteApi;
  canEdit: boolean;
  onClose: () => void;
  onOpenRun: (note: AssistantNoteApi) => void;
  onExport: (noteIds: string[]) => void;
  onDelete: (noteIds: string[]) => void;
}

function AgentNoteDetail({
  note,
  canEdit,
  onClose,
  onOpenRun,
  onExport,
  onDelete,
}: AgentNoteDetailProps) {
  return (
    <div className="d-flex flex-column h-100">
      <h2 className="h4-title">Agent Note</h2>

      <div style={{ flexGrow: 1, paddingTop: '1rem' }}>
        <div className="input-block d-flex flex-row justify-between">
          <div className="input-description">
            <div className="input-title">Type</div>
          </div>
          <div className="align-wrapper d-flex align-center">
            <p>{note.note_type}</p>
          </div>
        </div>
        <div className="input-block d-flex flex-row justify-between">
          <div className="input-description">
            <div className="input-title">Source</div>
          </div>
          <div className="align-wrapper d-flex align-center">
            <p>{getNoteSourceLabel(note.source)}</p>
          </div>
        </div>
        <div className="input-block d-flex flex-row justify-between">
          <div className="input-description">
            <div className="input-title">Created At</div>
          </div>
          <div className="align-wrapper d-flex align-center">
            <p>{formatDateTimeLocal(note.created_at)}</p>
          </div>
        </div>
        <div className="input-block d-flex flex-row justify-between">
          <div className="input-description">
            <div className="input-title">Note</div>
          </div>
          <div className="align-wrapper d-flex align-center">
            <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{note.text}</p>
          </div>
        </div>
      </div>

      <div className="buttons-container d-flex justify-end wrap">
        {note.run_key && (
          <Button variant="secondary" onClick={() => onOpenRun(note)}>
            Open Agent Run
          </Button>
        )}
        <Button variant="secondary" onClick={() => onExport([note.id])}>
          Export
        </Button>
        {canEdit && (
          <Button variant="danger" onClick={() => onDelete([note.id])}>
            Delete
          </Button>
        )}
        <Button variant="secondary" onClick={onClose}>
          Back
        </Button>
      </div>
    </div>
  );
}

export default AgentNoteDetail;
